import React from "react";
import useFetchData from "../../hooks/useFetchData";
import Input from "../FormComponents/Input";
import SingleSelectBox from "../FormComponents/SingleSelectBox";

const EditImageConfig = ({ editElementData, setEditElementData }) => {
  const handleChange = (name, value) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <>
      <Input
        value={editElementData?.source || ""}
        onChange={(e) => handleChange("source", e.target.value)}
        name="source"
        label="Image Source"
        type="text"
      />
      <ImageSelectorFromRepo
        selected={editElementData?.repo_source}
        onChange={(obj) => handleChange("repo_source", obj.id)}
      />
    </>
  );
};

const ImageSelectorFromRepo = ({ selected, onChange, label = "Select from repo" }) => {
  const { data, error, loading } = useFetchData(`/image_repo`);

  const transformData = (data) => {
    return data.map((item) => ({
      id: item.image_data.name,
      name: item.name
    }));
  };
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error while feching repo</div>;
  }
  return (
    <SingleSelectBox
      selectedData={selected}
      options={transformData(data)}
      onChange={onChange}
      placeholder="Select image"
      label={label}
    />
  );
};

export default EditImageConfig;
export { ImageSelectorFromRepo };
